import { isIterableSet } from './is.utils.js';
function iterToSet(iterable) {
  return isIterableSet(iterable) ? iterable : new Set(iterable);
}
function mergeIterables() {
  const items = [];
  for (var _len = arguments.length, iterables = new Array(_len), _key = 0; _key < _len; _key++) {
    iterables[_key] = arguments[_key];
  }
  iterables.forEach(iterable => {
    if (iterable) {
      items.push(...Array.from(iterable));
    }
  });
  return new Set(items);
}
export { iterToSet, mergeIterables };